/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Fade from 'react-reveal/Fade';
import { Splide, SplideSlide } from '@splidejs/react-splide';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default function Testimonial({ data }) {
  return (
    <Fade bottom>
      <section className="relative container mx-auto py-20 overflow-hidden">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-theme-purple/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-dark-theme-purple/5 rounded-full blur-3xl" />

        <div className="relative z-10">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-2xl mb-6">
              <svg className="w-10 h-10 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">Client Testimonials</h1>

            <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
              Discover what our clients have to say about their experiences with the software
              solutions we&apos;ve provided them.
            </p>
          </div>

          <Splide
            options={{
              type: 'loop',
              autoplay: true,
            }}
          >
            {
              data.map((item) => (
                <SplideSlide key={item.name}>
                  <div className="group relative flex-col xl:w-4/5 rounded-2xl shadow-lg border border-gray-100 bg-white px-8 py-8 mx-2 mb-6 mt-6 xl:mx-auto sm:mx-6 sm:mb-12 hover:shadow-xl hover:border-theme-purple/30 transition-all duration-300 overflow-hidden">
                    {/* Decorative gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-br from-theme-purple/5 to-dark-theme-purple/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                    {/* Quote icon decoration */}
                    <div className="absolute top-4 right-4 opacity-5 group-hover:opacity-10 transition-opacity duration-300">
                      <svg className="w-24 h-24 text-theme-purple" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.996 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.984zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                      </svg>
                    </div>

                    <div className="relative z-10">
                      <div className="flex items-center mb-6">
                        <div className="relative">
                          <img src={item.imageUrl} alt="Testimoni" className="w-20 h-20 rounded-full ring-4 ring-theme-purple/10 group-hover:ring-theme-purple/30 transition-all duration-300" />
                          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
                            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          </div>
                        </div>
                        <div className="flex-col pl-5">
                          <h2 className="text-theme-blue text-xl font-semibold group-hover:text-theme-purple transition-colors duration-300">{item.name}</h2>
                          <p className="font-light text-gray-500 text-sm mt-1">{item.company}</p>
                        </div>
                      </div>
                      <p className="font-light text-lg text-gray-600 leading-relaxed pl-5 pt-2 pb-1 italic relative">
                        <span className="absolute left-0 top-0 text-6xl text-theme-purple/10 font-serif leading-none">&ldquo;</span>
                        <span className="relative z-10">
                          {item.testimoni}
                        </span>
                        <span className="text-6xl text-theme-purple/10 font-serif leading-none">&rdquo;</span>
                      </p>
                    </div>
                  </div>
                </SplideSlide>
              ))
            }
          </Splide>
        </div>
      </section>
    </Fade>
  );
}
